import { render, staticRenderFns } from "./BtnBrown.vue?vue&type=template&id=2916e224&scoped=true&"
import script from "./BtnBrown.vue?vue&type=script&lang=js&"
export * from "./BtnBrown.vue?vue&type=script&lang=js&"
import style0 from "./BtnBrown.vue?vue&type=style&index=0&id=2916e224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916e224",
  null
  
)

export default component.exports